import { render, staticRenderFns } from "./BankStatementSection.vue?vue&type=template&id=36571cf6&scoped=true"
import script from "./BankStatementSection.vue?vue&type=script&lang=js"
export * from "./BankStatementSection.vue?vue&type=script&lang=js"
import style0 from "./BankStatementSection.vue?vue&type=style&index=0&id=36571cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36571cf6",
  null
  
)

export default component.exports